// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2lXyJ{margin:0 auto;text-align:center}._2cJHI td{padding:2px}", ""]);
// Exports
exports.locals = {
	"heatmap": "_2lXyJ",
	"tooltip": "_2cJHI"
};
module.exports = exports;
